import MD5 from 'crypto-js/md5';
import AES from 'crypto-js/aes';
import EncUTF8 from 'crypto-js/enc-utf8';

const isPro = ['production', 'prod'].includes(process.env.NODE_ENV);

const SECRET = 'SecretPassphrase';

function toObject(datastr) {
  let obj = datastr;
  if (datastr) {
    try {
      obj = JSON.parse(datastr);
    } catch (e) {
      obj = datastr;
    }
  }
  return obj;
}

function toString(obj) {
  if (typeof obj === 'object') {
    return JSON.stringify(obj);
  }
  return obj.toString();
}

export function isEmpty(obj) {
  if (obj === '' || obj === null || obj === undefined) {
    return true;
  }
  if (typeof obj === 'object') {
    return Object.keys(obj).length === 0;
  }

  return false;
}

const generateKey = (key) => (isPro ? MD5(key).toString() : key);

/**
 * 加密
 * @param {*} value
 */
const encrypt = (value) => {
  if (value !== undefined && !isEmpty(value)) {
    let encrypted = toString(value);
    return isPro ? AES.encrypt(encrypted, SECRET).toString() : encrypted;
  }
  return '';
};

/**
 * 解密
 * @param {*} input
 */
const decrypt = (input) => {
  if (!input) {
    return '';
  }
  let data = input;
  if (isPro) {
    let decrypted = AES.decrypt(input, SECRET);
    data = decrypted.toString(EncUTF8);
  }
  return toObject(data);
};

export const setSessionItem = (key, value) => {
  window.sessionStorage.setItem(generateKey(key), encrypt(value));
};

export const getSessionItem = (key) => {
  let data = window.sessionStorage.getItem(generateKey(key));
  return decrypt(data);
};
export const setLocalItem = (key, value) => {
  window.localStorage.setItem(generateKey(key), encrypt(value));
};

export const getLocalItem = (key) => {
  let data = window.localStorage.getItem(generateKey(key));
  return decrypt(data);
};

export const removeSessionItem = (key) => {
  window.sessionStorage.removeItem(generateKey(key));
};

export const removeLocalItem = (key) => {
  window.localStorage.removeItem(generateKey(key));
};

export default {
  session: {
    get: getSessionItem,
    set: setSessionItem,
    remove: removeSessionItem,
  },
  local: {
    get: getLocalItem,
    set: setLocalItem,
    remove: removeLocalItem,
  },
};
